import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { CampaignType } from '../models/CampaignType';

@Injectable({ providedIn: 'root' })

export class CampaignTypeService { 
  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/campaigntypes';   
  }
 
  getAll(): Observable<Array<CampaignType>> { 
    return this.http.get<Array<CampaignType>>(this._ENDPOINT);
  }
      
  getById(id: any): Observable<CampaignType> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<CampaignType>(url);
  }

  /** POST: add a new campaignType to the server */
  add(campaignType: CampaignType): Observable<CampaignType> {
    return this.http.post<CampaignType>(this._ENDPOINT, campaignType, this.httpOptions).pipe(
      tap((newCampaignType: CampaignType) => this.log('added campaignType w/ id=${newCampaignType.id}')),
      catchError(this.handleError<CampaignType>('add'))
    );
  }

  /** DELETE: delete the campaignType from the server */
  delete(campaignType: CampaignType | number): Observable<CampaignType> {
    const id = typeof campaignType === 'number' ? campaignType : campaignType.id;
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<CampaignType>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted campaignType id=${id}')),
      catchError(this.handleError<CampaignType>('delete'))
    );
  }

  /** PUT: update the campaignType on the server */
  update(id: number, campaignType: CampaignType): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, campaignType , this.httpOptions).pipe(
      tap(_ => this.log('updated campaignType id=${campaignType.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a CampaignTypeService message with the MessageService */
  private log(message: string) {
    this.messageService.add('CampaignTypeService: ${message}');
  }
}
